export default "__VITE_ASSET__D17gibXD__"